/**
 * Push Notification Prompt Modal
 *
 * Dismissable modal shown when push notification permissions are denied
 * on native iOS. Encourages the user to enable notifications but allows
 * them to skip via "Not Now".
 */

import { createPortal } from 'react-dom'
import styles from './PushNotificationEnforcementModal.module.css'

interface PushNotificationEnforcementModalProps {
  onOpenSettings: () => void
  onDismiss: () => void
}

export function PushNotificationEnforcementModal({
  onOpenSettings,
  onDismiss,
}: PushNotificationEnforcementModalProps) {
  return createPortal(
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-labelledby="push-enforcement-title">
      <div className={styles.card}>
        <div className={styles.iconWrapper} aria-hidden="true">
          <svg
            className={styles.icon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
        </div>
        <h2 id="push-enforcement-title" className={styles.title}>
          Enable Notifications
        </h2>
        <p className={styles.body}>
          Get notified about important updates, visit reminders, and team activity.
          You can change this anytime in Settings.
        </p>
        <button className={styles.button} onClick={onOpenSettings}>
          Enable Notifications
        </button>
        <button className={styles.secondaryButton} onClick={onDismiss}>
          Not Now
        </button>
      </div>
    </div>,
    document.body
  )
}
